"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var ApplePay = (function () {
    function ApplePay(paymentRequest) {
        this.appleSession = null;
        this.paymentRequestDefaults = {
            currencyCode: 'USD',
            countryCode: 'US',
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
            supportedNetworks: ['amex', 'masterCard', 'visa', 'discover'],
            requiredBillingContactFields: ['postalAddress', 'name'],
            requiredShippingContactFields: ['email', 'phone'],
            total: {
                label: 'iDonate',
                amount: '',
                type: 'final',
            },
        };
        this.paymentRequest = Object.assign({}, this.paymentRequestDefaults, paymentRequest);
    }
    ApplePay.isSupported = function () {
        return (window.ApplePaySession &&
            ApplePaySession.canMakePayments() &&
            ApplePaySession.supportsVersion(ApplePay.ApplePayApiVersion));
    };
    ApplePay.prototype.begin = function () {
        if (!ApplePay.isSupported()) {
            return Promise.reject(new Error('Apple Pay Not Supported'));
        }
        this.appleSession = new ApplePaySession(ApplePay.ApplePayApiVersion, this.paymentRequest);
        this.appleSession.begin();
        return Promise.resolve(this.appleSession);
    };
    ApplePay.prototype.createSession = function (payload, embedApiBaseUrl) {
        return fetch(embedApiBaseUrl + "/payment/create-session", {
            method: 'POST',
            headers: constants_1.CLIENT_HEADERS,
            body: JSON.stringify(payload),
        }).then(function (response) { return response.json(); });
    };
    ApplePay.prototype.tokenizeWithCardConnect = function (applePaymentMethod, cardConnectBaseUrl) {
        var paymentData = applePaymentMethod.token.paymentData;
        var token = paymentData.data;
        var ectype = 'apple';
        var ecsig = paymentData.signature;
        var eckey = paymentData.header.ephemeralPublicKey;
        var ectid = paymentData.header.transactionId;
        var ecpublickeyhash = paymentData.header.publicKeyHash;
        var dataString = token + "&ectype=" + ectype + "&ecsig=" + ecsig + "&eckey=" + eckey + "&ectid=" + ectid + "&echash=&ecpublickeyhash=" + ecpublickeyhash;
        return fetch(cardConnectBaseUrl + "/cardsecure/api/v1/ccn/tokenize", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                encryptionhandler: 'EC_APPLE_PAY',
                devicedata: dataString,
                unique: true,
            }),
        }).then(function (response) { return response.json(); });
    };
    ApplePay.ApplePayApiVersion = 6;
    return ApplePay;
}());
exports.default = ApplePay;
